module.exports = __webpack_public_path__ + "resources/images/creditcard-8b2e98122383baff8b36e7f33aae96dc-cache.jpg";